import React, { useState } from 'react';
import { Camera, Image, Play, Settings, PackageSearch, Mail, ArrowRight } from 'lucide-react';
import ProductModal from '../components/ProductModal';
import Card from '../components/ui/Card';
import CardContent from '../components/ui/CardContent';
import Layout from '../components/Layout';

const ServiceWebsite = () => {
  const [selectedService, setSelectedService] = useState(null);
  
  const handlePaymentSubmit = async (data) => {
    try {
      const response = await fetch('https://api.photo-mir.shop/api/create-payment', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });
      
      if (!response.ok) {
        throw new Error('Failed to create payment');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Payment error:', error);
      throw new Error('Ошибка при создании платежа. Пожалуйста, попробуйте позже.');
    }
  };

  const services = [
    {
      id: 1,
      name: "Портретная фотосессия",
      description: "Индивидуальная фотосессия в студии (30 минут)",
      priceRange: "1 000 ₽",
      includes: ["30 минут съёмки", "5 фото в обработке", "Цифровые файлы"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-violet-500 to-purple-500"
    },
    {
      id: 2,
      name: "Базовая ретушь фото",
      description: "Профессиональная обработка до 10 фотографий",
      priceRange: "2 000 ₽",
      includes: ["Цветокоррекция", "Базовая ретушь", "Форматирование"],
      icon: <Image className="w-6 h-6" />,
      color: "from-blue-500 to-cyan-500"
    },
    {
      id: 3,
      name: "Предметная съёмка",
      description: "Фотосъёмка товаров для интернет-магазина",
      priceRange: "3 000 ₽",
      includes: ["До 10 предметов", "Базовая обработка", "Белый фон"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-emerald-500 to-teal-500"
    },
    {
      id: 4,
      name: "Короткий видеоролик",
      description: "Создание рекламного видео до 30 секунд",
      priceRange: "4 000 ₽",
      includes: ["Съёмка", "Простой монтаж", "Музыка"],
      icon: <Play className="w-6 h-6" />,
      color: "from-orange-500 to-amber-500"
    },
    {
      id: 5,
      name: "Расширенная фотосессия",
      description: "Часовая фотосессия в студии или на улице",
      priceRange: "5 000 ₽",
      includes: ["60 минут съёмки", "15 фото", "Смена образов"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-rose-500 to-pink-500"
    },
    {
      id: 6,
      name: "Продвинутая ретушь",
      description: "Глубокая ретушь портретов и предметных фото",
      priceRange: "6 000 ₽",
      includes: ["До 5 фото", "Глубокая ретушь", "Замена фона"],
      icon: <Image className="w-6 h-6" />,
      color: "from-violet-500 to-purple-500"
    },
    {
      id: 7,
      name: "Свадебная минифотосессия",
      description: "Короткая свадебная фотосессия для небольших торжеств",
      priceRange: "7 000 ₽",
      includes: ["2 часа съёмки", "50 фото", "Экспресс-обработка"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-blue-500 to-cyan-500"
    },
    {
      id: 8,
      name: "Видеосъёмка мероприятия",
      description: "Видеосъёмка небольшого мероприятия до 2 часов",
      priceRange: "8 000 ₽",
      includes: ["2 часа съёмки", "Базовый монтаж", "Цветокоррекция"],
      icon: <Play className="w-6 h-6" />,
      color: "from-emerald-500 to-teal-500"
    },
    {
      id: 9,
      name: "Бизнес-портреты",
      description: "Профессиональные фото для бизнес-профилей",
      priceRange: "9 000 ₽",
      includes: ["Несколько образов", "10 фото", "Деловой стиль"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-orange-500 to-amber-500"
    },
    {
      id: 10,
      name: "Рекламный видеоролик",
      description: "Создание продающего видео для вашего продукта",
      priceRange: "10 000 ₽",
      includes: ["Сценарий", "Съёмка", "Монтаж"],
      icon: <Play className="w-6 h-6" />,
      color: "from-rose-500 to-pink-500"
    },
    {
      id: 11,
      name: "Семейная фотосессия",
      description: "Полноценная семейная фотосессия на природе",
      priceRange: "11 000 ₽",
      includes: ["2 часа съёмки", "30 фото", "Несколько локаций"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-violet-500 to-purple-500"
    },
    {
      id: 12,
      name: "Видеоконтент для соцсетей",
      description: "Пакет видеороликов для социальных сетей",
      priceRange: "12 000 ₽",
      includes: ["5 роликов", "Монтаж", "Оптимизация"],
      icon: <Play className="w-6 h-6" />,
      color: "from-blue-500 to-cyan-500"
    },
    {
      id: 13,
      name: "Корпоративная фотосъёмка",
      description: "Фотосъёмка офиса и сотрудников компании",
      priceRange: "13 000 ₽",
      includes: ["3 часа съёмки", "Портреты", "Репортаж"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-emerald-500 to-teal-500"
    },
    {
      id: 14,
      name: "Промо-видео",
      description: "Создание промо-ролика для вашего бизнеса",
      priceRange: "14 000 ₽",
      includes: ["Концепция", "Съёмка", "Анимация"],
      icon: <Play className="w-6 h-6" />,
      color: "from-orange-500 to-amber-500"
    },
    {
      id: 15,
      name: "Fashion-фотосессия",
      description: "Модная фотосессия с профессиональной командой",
      priceRange: "15 000 ₽",
      includes: ["Стилист", "Визажист", "20 фото"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-rose-500 to-pink-500"
    },
    {
      id: 16,
      name: "Свадебное видео",
      description: "Видеосъёмка свадебного торжества",
      priceRange: "16 000 ₽",
      includes: ["6 часов съёмки", "Клип", "Фильм"],
      icon: <Play className="w-6 h-6" />,
      color: "from-violet-500 to-purple-500"
    },
    {
      id: 17,
      name: "Аэросъёмка",
      description: "Профессиональная съёмка с дрона",
      priceRange: "17 000 ₽",
      includes: ["2 часа съёмки", "Монтаж", "4K качество"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-blue-500 to-cyan-500"
    },
    {
      id: 18,
      name: "Музыкальный клип",
      description: "Создание музыкального видеоклипа",
      priceRange: "18 000 ₽",
      includes: ["Режиссура", "Съёмка", "Монтаж"],
      icon: <Play className="w-6 h-6" />,
      color: "from-emerald-500 to-teal-500"
    },
    {
      id: 19,
      name: "Рекламная фотосессия",
      description: "Полный день рекламной фотосъёмки",
      priceRange: "19 000 ₽",
      includes: ["8 часов съёмки", "Команда", "Локации"],
      icon: <Camera className="w-6 h-6" />,
      color: "from-orange-500 to-amber-500"
    },
    {
      id: 20,
      name: "Премиум видеопродакшн",
      description: "Полный цикл создания видеоконтента",
      priceRange: "20 000 ₽",
      includes: ["Сценарий", "Съёмка", "Постпродакшн"],
      icon: <Play className="w-6 h-6" />,
      color: "from-rose-500 to-pink-500"
    }
  ];

  return (
    <Layout>
      {/* Hero Section */}
      <section className="relative -mt-8 py-32 bg-gradient-to-br from-gray-900 to-gray-800 text-white overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-purple-500/20" />
        </div>
        <div className="relative max-w-5xl mx-auto px-4 sm:px-6">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-200 to-purple-200">
              Профессиональная фото и видеосъёмка
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto leading-relaxed">
              Создаём качественный визуальный контент для вашего бизнеса и личных событий
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6">
              <button 
                onClick={() => setSelectedService(services[0])}
                className="px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-200 transform hover:scale-105"
              >
                Заказать съёмку
              </button>
              <button className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white rounded-lg font-medium backdrop-blur-sm transition-all duration-200 transform hover:scale-105">
                Узнать больше
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Наши услуги</h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Предоставляем полный спектр услуг в сфере фото и видео производства
            </p>
          </div>
          
          <div className="grid gap-8 md:grid-cols-2">
            {services.map((service) => (
              <Card 
                key={service.id} 
                className="group hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
              >
                <CardContent>
                  <div className="flex items-start space-x-6">
                    <div className={`p-4 rounded-2xl bg-gradient-to-r ${service.color} transform group-hover:scale-110 transition-transform duration-300`}>
                      <div className="text-white">
                        {service.icon}
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                        {service.name}
                      </h3>
                      <p className="text-gray-600 mb-4">
                        {service.description}
                      </p>
                      <ul className="space-y-3 mb-6">
                        {service.includes.map((item, index) => (
                          <li key={index} className="flex items-center text-gray-600">
                            <ArrowRight className="w-4 h-4 mr-2 text-gray-400" />
                            {item}
                          </li>
                        ))}
                      </ul>
                      <div className="flex justify-between items-center">
                        <span className="text-xl font-bold bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent">
                          {service.priceRange}
                        </span>
                        <button 
                          onClick={() => setSelectedService(service)}
                          className={`px-6 py-3 rounded-lg text-white bg-gradient-to-r ${service.color} transform transition-all duration-300 hover:scale-105 hover:shadow-lg font-medium`}
                        >
                          Заказать
                        </button>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Свяжитесь с нами</h2>
            <p className="text-xl text-gray-600">
              Готовы обсудить ваш проект и ответить на вопросы
            </p>
          </div>
          
          <div className="bg-gray-50 rounded-2xl shadow-lg p-8">
            <div className="flex flex-col items-center justify-center space-y-6">
              <a 
                href="mailto:Oleg.platov.04@mail.ru" 
                className="flex items-center justify-center space-x-3 p-4 w-full sm:w-auto rounded-xl bg-white hover:bg-gray-50 transition-colors duration-200 group"
              >
                <Mail className="w-6 h-6 text-blue-600" />
                <span className="text-lg font-medium text-gray-900">Oleg.platov.04@mail.ru</span>
              </a>
              
              <div className="w-full pt-6 border-t border-gray-200">
                <div className="text-center text-sm text-gray-600">
                  <p className="mb-2">ИП Платов Олег Сергеевич</p>
                  <p className="mb-2">ОГРНИП: 324774600271475</p>
                  <p>ИНН: 772840374009</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Product Modal */}
      <ProductModal
        service={selectedService}
        isOpen={!!selectedService}
        onClose={() => setSelectedService(null)}
        onSubmit={handlePaymentSubmit}
      />
    </Layout>
  );
};

export default ServiceWebsite;